<script>
import MainDocument from "@/components/helpers/MainDocument.vue";

export default {
  components: { MainDocument },

  data() {
    return {
      isLoading: false,
      documentTitle: "",
    };
  },

  methods: {
    async getFileInfo() {
      try {
        this.isLoading = true;

        const response = await fetch(
          "https://esd.docs-lab.ru/info/document/103",
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          console.error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        this.documentTitle = data.name;
      } catch (error) {
        console.error("Ошибка при получении данных:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },

  mounted() {
    this.getFileInfo();
  },
};
</script>

<template>
  <div class="calculator-personal-gain-notice">
    <h5 class="calculator-personal-gain-notice__title">
      Рассчитайте свой заработок наперед
    </h5>

    <p class="calculator-personal-gain-notice__text">
      В этом разделе вы сможете строить оптимальные стратегии приглашений и
      оценивать влияние своих действий на прибыль. Вычисления основаны на плане
      агентских вознаграждений:
    </p>

    <main-document
      v-if="!isLoading"
      :title="documentTitle"
      url="https://esd.docs-lab.ru/document/download/3"
    />
  </div>
</template>

<style lang="scss" scoped>
.calculator-personal-gain-notice {
  background-color: $light-primary;
  border-radius: $space-m;
  padding: 40px;
  max-width: 692px;

  &__title {
    @include body-1-bold;
    color: $dark-primary;
    margin-bottom: $space-s;
  }

  &__text {
    @include text-2;
    color: $dark-primary;
    margin-bottom: $space-xl;
  }

  @media (max-width: 425px) {
    padding: $space-l;
  }
}
</style>
